import { webPushViewerKey } from "@/lib/webPushViewerKey";

interface BoundWebPushViewer {
  identity: "guest" | "member";
  userId: string;
}

/** Commits a confirmed bind only while the bound account still owns this browser view. */
export function resolveSuccessfulWebPushBinding(
  session: BoundWebPushViewer,
  ownership: {
    currentViewerKey: string;
    startedViewerKey: string;
  },
) {
  const resolvedViewerKey = webPushViewerKey(session);
  const currentOwnsBinding = resolvedViewerKey === ownership.currentViewerKey;
  const visitorTransitionPending = [
    ownership.startedViewerKey === "visitor:none",
    ownership.currentViewerKey === ownership.startedViewerKey,
  ].every(Boolean);
  if (![currentOwnsBinding, visitorTransitionPending].some(Boolean)) return null;

  return {
    resolvedViewerKey,
    serverBound: true as const,
  };
}
